<div
  class="new_report_sidemenu_overlay"
  (click)="cancelNewReport()"
  (keydown)="null"
></div>

<div
  class="new_report_sidemenu"
  role="dialog"
  aria-modal="true"
  aria-labelledby="new-report-sidemenu-title"
  cdkTrapFocus
>
  <header class="new_report_sidemenu_header">
    <h2
      id="new-report-sidemenu-title"
      class="new_report_sidemenu_title"
    >
      {{ 'TRANS__REPORTS_V2_CREATE_SIDEBAR_TITLE' | translate }}
    </h2>

    <button
      mat-icon-button
      type="button"
      class="new_report_sidemenu_close"
      [attr.aria-label]="'TRANS__BUTTON__CLOSE' | translate"
      (click)="cancelNewReport()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form
    #reportForm="ngForm"
    class="new_report_sidemenu_form"
    novalidate
    (ngSubmit)="submit(reportForm)"
  >
    <div class="new_report_sidemenu_content">
      <p class="new_report_sidemenu_intro">
        {{ 'TRANS__REPORTS_V2_CREATE_SIDEBAR_GENERATE_FOR' | translate }} {{ selectedCount }} {{ 'TRANS__REPORTS_V2_CREATE_SIDEBAR_ITEMS_SELECTED' | translate }}.
      </p>

      @if (newReport) {
        <mat-form-field>
          <mat-label>{{ 'TRANS__REPORTS_V2_CREATE_SIDEBAR_REPORT_TITLE' | translate }}</mat-label>
          <input
            matInput
            type="text"
            name="title"
            autocomplete="off"
            required
            [(ngModel)]="newReport.name"
          />
          <mat-error>{{ 'TRANS__REPORTS_V2_CREATE_REPORT_NAME_ERROR' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'TRANS__REPORTS_V2_CREATE_SIDEBAR_SHORT_DESC' | translate }}</mat-label>
          <textarea
            matInput
            name="shortDescription"
            rows="5"
            [placeholder]="'TRANS__REPORTS_V2_CREATE_SIDEBAR_SHORT_DESC_PLACEHOLDER' | translate"
            [(ngModel)]="newReport.shortDescription"
          ></textarea>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'TRANS__REPORTS_V2_CREATE_SIDEBAR_CHOOSE_REPORT_VIEW_SHORT' | translate }}</mat-label>
          <mat-select
            name="reportViewType"
            required
            [(ngModel)]="newReport.reportViewTypeId"
          >
            @for (reportView of selectableReportViewTypes; track reportView.id) {
              <mat-option [value]="reportView.id">
                {{ reportView.name }}
              </mat-option>
            }
          </mat-select>
          <mat-error>{{ 'TRANS__REPORTS_V2_CREATE_REPORT_VIEW_ERROR' | translate }}</mat-error>
        </mat-form-field>
      }
    </div>

    <footer class="new_report_sidemenu_actions">
      <button
        mat-stroked-button
        type="button"
        class="new_report_sidemenu_cancel"
        (click)="cancelNewReport()"
      >
        {{ 'TRANS__REPORTS_V2_BUTTON_CANCEL' | translate }}
      </button>

      <button
        mat-flat-button
        type="submit"
        class="new_report_sidemenu_next"
      >
        {{ 'TRANS__REPORTS_V2_BUTTON_NEXT' | translate }}
      </button>
    </footer>
  </form>
</div>
